import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import commodity from '../commodity/commodity.vue';
import i18n from '@/pages/design/locale/i18n';
export default {
  name: "waterfall",
  components: {
    commodity: commodity
  },
  props: {
    List: Array,
    scrollHeight: Number,
    type: {
      //1我的收藏页面，2其他页面
      type: Number,
      default: 2
    },
    showEnd: Boolean
  },
  data: function data() {
    return {
      // 避免重复提交
      isClick: false,
      scrollTop: 0,
      old: {
        scrollTop: 0
      },
      i18n: i18n
    };
  },
  created: function created() {
    var lang = localStorage.langCode;
    this.i18n.locale = lang;
    this.$t = this.i18n.t.bind(this.i18n);
  },
  methods: {
    //滑动到底
    lower: function lower() {
      // console.log('到底了')
      // this.index++
      // setTimeout(()=>{
      // 	// this.getData()
      // },1000)
      this.$emit('lower');
    },
    getStyle: function getStyle() {
      if (this.scrollHeight && this.scrollHeight > 0) {
        return {
          height: this.scrollHeight + 'px'
        };
      }
      return {};
    },
    scroll: function scroll(e) {
      // console.log(e)
      this.old.scrollTop = e.detail.scrollTop;
    },
    goTop: function goTop(e) {
      var _this = this;
      this.scrollTop = this.old.scrollTop;
      this.$nextTick(function () {
        _this.scrollTop = 0;
      });
    },
    //取消收藏
    cancel: function cancel(e) {
      var _this2 = this;
      // 避免重复提交
      if (this.isClick) return;
      this.isClick = true;
      this.$api.my_collection.cancel_collection({
        id: e.item.productSpecificationId
      }).then(function (res) {
        if (res.code === 200) {
          _this2.List.splice(e.index, 1);
          _this2.$refs.uToast.show({
            title: _this2.$t('my_collection.del_success')
          });
        } else {
          _this2.$refs.uToast.show({
            title: res.message
          });
        }
      }).finally(function () {
        _this2.isClick = false;
      });
    },
    //跳转商品详情
    toProductDetails: function toProductDetails(item) {
      // console.log(item)
      // this.$u.route({
      //   url: '/product/product',
      //   params: {
      //     productNo: item.productNo
      //   }
      // })
    }
  }
};